import { Button, Grid } from "@aws-amplify/ui-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import LocalizedStrings from "react-localization";
import { API, graphqlOperation } from "aws-amplify";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

import ItemListCollection from "../ItemListCollection";
import { listCompanies } from "graphql/queries";
import { LayoutContext } from "layout/context/LayoutContext";

export const CompaniesChoose = ({
  initCompaniesGranted = [],
  onChangeCompaniesGranted,
  resetValues,
}) => {
  const { me } = useContext(LayoutContext);
  const [companiesAvailable, setCompaniesAvailable] = useState([]);
  const [companiesGranted, setCompaniesGranted] = useState([]);
  const [companiesAvailableSelected, setCompaniesAvailableSelected] = useState(
    []
  );
  const [companiesGrantedSelected, setCompaniesGrantedSelected] = useState([]);
  const [keywordCompaniesGranted, setKeywordCompaniesGranted] = useState("");
  const [loading, setLoading] = useState(false);

  async function fetchCompaniesAvailable(keyword, diffCompanies) {
    let filterObj = {};
    try {
      setLoading(true);
      if (me.companyID)
        filterObj = { ...filterObj, or: [{ id: { eq: me.companyID } }] };
      if (me.managedCompanies.length > 0)
        filterObj = {
          ...filterObj,
          or: [
            ...(filterObj?.or ?? []),
            ...me.managedCompanies.map((cp) => ({ id: { eq: cp } })),
          ],
        };
      const companiesData = await API.graphql(
        graphqlOperation(listCompanies, {
          filter: keyword
            ? {
                and: [
                  {
                    or: [
                      {
                        name: { contains: keyword },
                      },
                    ],
                  },
                  {
                    ...filterObj,
                  },
                ],
              }
            : { ...filterObj },
        })
      );
      const companiesItems = companiesData.data.listCompanies.items;
      const companiesGrantedExist = companiesItems?.filter((companyItem) =>
        diffCompanies?.some((diffUs) => diffUs === companyItem.id)
      );

      setCompaniesGranted(companiesGrantedExist);
      setCompaniesAvailable(
        companiesItems
          ?.filter(
            (companyItem) =>
              !companiesGrantedExist?.some(
                (diffUs) => diffUs.id === companyItem.id
              )
          )
          ?.map((companyItem) => ({
            id: companyItem.id,
            name: companyItem.name,
          }))
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCompaniesAvailable(undefined, initCompaniesGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initCompaniesGranted, resetValues]);

  useEffect(() => {
    if (onChangeCompaniesGranted) onChangeCompaniesGranted(companiesGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companiesGranted]);

  const cleanSelected = () => {
    setCompaniesAvailableSelected([]);
    setCompaniesGrantedSelected([]);
  };

  const setInAvailable = (items) => {
    if (!items || items?.length <= 0) return;
    setCompaniesAvailable((prevSt) => [...prevSt, ...items]);
    setCompaniesGranted((prevSt) =>
      prevSt.filter((prev) => !items?.some((company) => company.id === prev.id))
    );
    cleanSelected();
  };

  const setInGranted = (items) => {
    if (!items || items?.length <= 0) return;
    setCompaniesGranted((prevSt) => [...prevSt, ...items]);
    setCompaniesAvailable((prevSt) =>
      prevSt.filter((prev) => !items?.some((company) => company.id === prev.id))
    );
    cleanSelected();
  };

  const onSearchCompaniesGranted = (keyword) => {
    setKeywordCompaniesGranted(keyword);
  };

  return (
    <Grid templateColumns={{ base: "1fr", large: "2fr 1fr 2fr" }} gap="30px">
      <div>
        <div className="fs-5 mb-3">{strings.companies.available}</div>
        <ItemListCollection
          items={companiesAvailable}
          selectedItems={companiesAvailableSelected}
          setSelectedItems={setCompaniesAvailableSelected}
          onSearchSubmit={(keyword) =>
            fetchCompaniesAvailable(keyword, companiesGranted)
          }
          loading={loading}
        />
      </div>
      <div style={styles.containerButtons}>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(companiesGrantedSelected)}
        >
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(companiesGranted)}
        >
          <IoIosArrowBack />
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(companiesAvailableSelected)}
        >
          <IoIosArrowForward />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(companiesAvailable)}
        >
          <IoIosArrowForward />
          <IoIosArrowForward />
        </Button>
      </div>
      <div>
        <div className="fs-5 mb-3">{strings.companies.granted}</div>
        <ItemListCollection
          items={
            keywordCompaniesGranted
              ? companiesGranted.filter((companyGr) =>
                  companyGr.name
                    .toLowerCase()
                    .includes(keywordCompaniesGranted?.toLowerCase())
                )
              : companiesGranted
          }
          selectedItems={companiesGrantedSelected}
          setSelectedItems={setCompaniesGrantedSelected}
          onSearchSubmit={onSearchCompaniesGranted}
        />
      </div>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    companies: {
      available: "Empresas disponibles",
      granted: "Empresas asociadas",
    },
    responses: {
      errorFetch: "Error al consultar empresas",
    },
  },
});

const styles = {
  containerButtons: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    gap: "10px",
  },
  buttonActions: {
    width: "65px",
    alignSelf: "center",
  },
};

export default CompaniesChoose;
